import { render, staticRenderFns } from "./BillAdjustmentRules.vue?vue&type=template&id=2a394058&scoped=true&"
import script from "./BillAdjustmentRules.vue?vue&type=script&lang=js&"
export * from "./BillAdjustmentRules.vue?vue&type=script&lang=js&"
import style0 from "./BillAdjustmentRules.vue?vue&type=style&index=0&id=2a394058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a394058",
  null
  
)

export default component.exports